const getProfilePicUrl = (filename) =>
  `https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/${filename}`;

export default getProfilePicUrl;
